import React from 'react';
import HeroSection from '../HeroSection';
import RecentPub from '../RecentPub';
import '../css/App.css';

function Home() {
  return (
    <>
      <HeroSection />
      <RecentPub />
    </>
  )
}

export default Home;